module.exports = __webpack_public_path__ + "static/media/firefox.ffa00c88.svg";